<template>
  <div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        v-loading="listLoading"
        border
    >
      <el-table-column property="" label="注册类型">
        <template #default="scope">
          <span>{{scope.row.type==1?'注册手机号':scope.row.type==2?'注册提交身份证':scope.row.type==3?'提交身份证免费进入':scope.row.type==4?'邀请码进入':scope.row.type==5?'认证费进入':scope.row.type==6?'保证金进入':scope.row.type==7?'保证金+邀请码':scope.row.type==8?'直接进入':scope.row.type==9?'芝麻认证进入':scope.row.type==10?'身份证直接进入':''}}</span>
        </template>
      </el-table-column>
      <el-table-column property="channel" label="渠道号"/>
      <el-table-column property="versionId" label="版本号"/>
      <el-table-column property="createTime" label="平台">
        <template #default="scope">
          <p>{{ scope.row.platformType == 1?'Android':scope.row.platformType ==2?'ios':scope.row.platformType ===4?'鸿蒙':'' }}</p>
        </template>
      </el-table-column>
      <el-table-column property="platformInfo" label="平台信息" width="300"/>
      <el-table-column property="" label="审核版">
        <template #default="scope">
          <p>{{ scope.row.isCheck == 0?'否':scope.row.isCheck ==1?'是':'' }}</p>
        </template>
      </el-table-column>
      <el-table-column property="createTime" label="创建时间" width="240"/>
    </el-table>
  </div>
</template>

<script>
import { listUserChannelDt } from '@/api/url'
import { getFormData } from '@/api/api'
export default {
  name: "enterFreeList",
  props: {
    value: Object
  },
  data() {
    return {
      phone: this.value.phone,
      userId: this.value.userId,
      listLoading: false,
      pageDataList: []
    }
  },
  methods: {
    getPage() {
      this.listLoading = true;
      let param= {}
      param['userId']= this.userId
      param['phone']= this.phone
      getFormData(listUserChannelDt, param).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          // let result = data['data'];
          this.pageDataList = data['data'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.listLoading = false;
      })
    }
  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
